if (!window.__IDS_FMS_BOOTED) {
window.__IDS_FMS_BOOTED = true;
/* ===== Inner Dragon  Find My Size v13.0 =====
   v13.0: תיקוני לוגיקה (ביקורת מחשבון, אוגוסט 2026)
   - חלופת מידה מוצעת רק כשהיא סמוכה (פער של מידה אחת), לא L/S.
   - גבול עליון: 2 ס"מ אחרונים בטווח (EDGE=2) לפי הנהוג בענף.
   - מידה שלא קיימת במוצר נופלת למידה הקיימת הקרובה + הסבר.
   - "התאמה גבוהה" רק במסלול מדידה, בתוך הטווח, בדגם שיושב לפי המידה.
   - גזרה: שדה fit_stats.shift מפורש (1/0/-1) עם נפילה למילות מפתח.
   - ג'קט רחב: "שקלי מידה מתחת" רק במידות XS-M ובלי פער בין המדדים.
   - שאלון: מידה רגילה נשמרת בנפרד לעליון ולתחתון.
   - שאלון: צ'יפ XS וירטואלי בדגמים שמתחילים מ-S.
   - edge_hint מוצג רק על הגבול העליון של XS במסלול מדידה.
   - אירוע recommend נורה רק אחרי אינטראקציה (לא בטעינה).
   - גובה 170+ באוברול: עלייה מדורגת (175+ תמיד, 170-174 מהחצי העליון).
   v13.3 (UX): התשובה בתוך הגלולה האפורה, שורת הסתייגות אחת, בלי רווחים מיותרים.
   v13.2 (UX): כרטיס תוצאה נקי - מידה, שורת הסבר, סיכום קטן מתחת; דיסקליימר בטולטיפ.
   v13.1 (UX): שאלון בשני שלבים (מידה -> גזרה -> תוצאה); שורת סיכום לחיצה
   במקום "שינוי"; "המידה שלך:" מעל המידה; הבורר חוזר למצב ההתחלתי כשמאפסים.
   v12.1: תיקון באג המידות בסל — הבחירה האוטומטית של המידה
   המומלצת עוברת עכשיו דרך click() אמיתי גם לפני אינטראקציה,
   כך שהתמה (variant-selects / product-form / sticky bar) מסונכרנת
   ולא נשארת על הווריאנט הראשון (XS). */
(function () {
  'use strict';

  // Share in-flight catalogue requests across sizes; short-lived, page-memory only.
  var altRequests = new Map();
  function altJSON(url) {
    var entry = altRequests.get(url);
    if (entry && Date.now() - entry.time < 60000) return entry.promise;
    var promise = fetch(url).then(function (response) {
      if (!response.ok) throw new Error('Alternative products unavailable');
      return response.json();
    }).catch(function (error) { altRequests.delete(url); throw error; });
    altRequests.set(url, {time: Date.now(), promise: promise});
    return promise;
  }

  var STD_BUST  = [[74,82],[83,88],[89,95],[96,102],[103,108]];
  var STD_WAIST = [[57,63],[64,70],[71,76],[77,82],[83,88]];
  var STD_HIPS  = [[79,86],[87,93],[94,100],[101,106],[107,112]];

  var CHARTS = {
    top_std:    { sizes: ['XS','S','M','L','XL'], fields: ['bust'],
                  m: { bust: STD_BUST } },
  tank:       { sizes: ['XS','S','M','L','XL'], fields: ['bust','waist'],
                  optional: ['waist'],
                  m: { bust: [[74,82],[83,90],[91,96],[97,102],[103,108]], waist: STD_WAIST } },
   top_naia:   { sizes: ['XS','S','M','L','XL'], fields: ['bust'],
                  m: { bust: [[74,82],[83,90],[91,95],[96,100],[101,105]] } },
    top_hera:   { sizes: ['S','M','L','XL'], fields: ['bust'],
                  m: { bust: [[83,88],[89,95],[96,102],[103,108]] } },
    top_dragon: { sizes: ['S','M','L','XL'], fields: ['bust'],
                  m: { bust: [[83,88],[89,95],[96,102],[103,108]] } },
    jacket:     { sizes: ['XS','S','M','L','XL'], fields: ['bust'],
                  m: { bust: [[74,83],[84,90],[91,96],[97,102],[103,108]] } },
    bottom_std: { sizes: ['XS','S','M','L','XL'], fields: ['waist','hips'],
                  m: { waist: STD_WAIST, hips: STD_HIPS } },
    bottom_xs_l:{ sizes: ['XS','S','M','L'], fields: ['waist','hips'],
                  m: { waist: [[57,63],[64,70],[71,76],[77,82]], hips: [[79,86],[87,93],[94,100],[101,106]] } },
    overall:    { sizes: ['XS','S','M','L','XL'], fields: ['bust','waist','hips','height'],
                  heightRule: true,
                  m: { bust: [[79,86],[87,93],[94,100],[101,106],[107,112]], waist: STD_WAIST, hips: STD_HIPS } },
    swim:       { sizes: ['XS','S','M','L','XL'], fields: ['bust','waist','hips'],
                  m: { bust: [[80,86],[86,90],[90,94],[94,98],[98,102]],
                       waist: [[62,66],[66,70],[70,74],[74,78],[78,82]],
                       hips:  [[87,90],[92,96],[96,100],[100,104],[104,108]] } }
  };

  var FIELD_NAMES = { bust: 'היקף חזה', waist: 'היקף מותן', hips: 'היקף ירכיים', height: 'גובה' };
  var ABOVE_MARGIN = 1, BELOW_MARGIN = 2, EDGE = 2;
  var DEFAULT_SUMTITLE = 'מצאי את המידה שלך'; /* IDS 3.11.2026: ניסוח חיובי במקום שאלה שמכניסה ספק */
  var SELECT_SETTLE = 350;
  var VERIFY_STEP = 120;
  var VERIFY_MAX = 2000;
  var DONE_CLOSE = 700;
  var RECOMMEND_CLOSE = 4000;

  var FITS = [{ v: 'true', label: 'כרגיל' }, { v: 'relaxed', label: 'משוחרר' }];

  function bandIndex(v, R) {
    for (var i = 0; i < R.length; i++) { if (v >= R[i][0] && v <= R[i][1]) return i; }
    return v < R[0][0] ? 0 : R.length - 1;
  }
  function isUpperEdge(v, R) {
    var i = bandIndex(v, R);
    return v >= R[i][0] && v <= R[i][1] && (R[i][1] - v) <= EDGE;
  }
  function tooHigh(v, R) { return v > R[R.length - 1][1] + ABOVE_MARGIN; }
  function tooLow(v, R)  { return v < R[0][0] - BELOW_MARGIN; }
  function clampIdx(i, n) { return Math.max(0, Math.min(n - 1, i)); }

  /* ===== cart-add network hook: covers EVERY add-to-cart path for the current product ===== */
  (function installIdsCartHook() {
    if (window.__idsCartHook || !window.fetch) return;
    window.__idsCartHook = true;
    var origFetch = window.fetch;
    function decorate(body) {
      var rec = window.__idsActiveRec;
      if (!rec || !rec.value) return body;
      try {
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
          var fid = body.get('id');
          if (fid && rec.ids[String(fid)] && !body.get('properties[_size_finder]')) {
            body.append('properties[_size_finder]', rec.value);
          }
          return body;
        }
        if (typeof body === 'string' && body.length) {
          if (body.charAt(0) === '{') {
            var data = JSON.parse(body);
            if (data && data.id && rec.ids[String(data.id)]) {
              data.properties = data.properties || {};
              if (!data.properties['_size_finder']) data.properties['_size_finder'] = rec.value;
              return JSON.stringify(data);
            }
            if (data && data.items && data.items.length) {
              var changed = false;
              for (var ii = 0; ii < data.items.length; ii++) {
                var it = data.items[ii];
                if (it && it.id && rec.ids[String(it.id)]) {
                  it.properties = it.properties || {};
                  if (!it.properties['_size_finder']) { it.properties['_size_finder'] = rec.value; changed = true; }
                }
              }
              if (changed) return JSON.stringify(data);
            }
            return body;
          }
          var m = body.match(/(?:^|&)id=(\d+)/);
          if (m && rec.ids[m[1]] && body.indexOf('_size_finder') < 0) {
            return body + '&' + encodeURIComponent('properties[_size_finder]') + '=' + encodeURIComponent(rec.value);
          }
        }
      } catch (e) {}
      return body;
    }
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        if (url.indexOf('/cart/add') >= 0 && init && init.body) {
          init.body = decorate(init.body);
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  })();

  var LS_KEY = 'ids_measures_v1';
  function loadSaved() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || {}; } catch (e) { return {}; }
  }
  function saveMeasures(vals) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(vals)); } catch (e) {}
  }
  function clearSaved() {
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
  }
  /* v13: המידה הרגילה נשמרת בנפרד לעליון ולתחתון (ids_quick_v2).
     מפתח v1 הישן נקרא פעם אחת כגיבוי לעליון בלבד ואז לא נוגעים בו. */
  var LS_QUICK = 'ids_quick_v2';
  var LS_QUICK_V1 = 'ids_quick_v1';
  function loadQuickAll() {
    try { return JSON.parse(localStorage.getItem(LS_QUICK)) || {}; } catch (e) { return {}; }
  }
  function loadQuick(cat) {
    var all = loadQuickAll();
    if (all[cat] && all[cat].usual) return all[cat];
    if (cat === 'top') {
      try {
        var old = JSON.parse(localStorage.getItem(LS_QUICK_V1));
        if (old && old.usual) return { usual: old.usual, fit: old.fit };
      } catch (e) {}
    }
    return {};
  }
  function saveQuick(cat, usual, fit) {
    try {
      var all = loadQuickAll();
      all[cat] = { usual: usual, fit: fit };
      localStorage.setItem(LS_QUICK, JSON.stringify(all));
    } catch (e) {}
  }
  function clearQuick() {
    try { localStorage.removeItem(LS_QUICK); localStorage.removeItem(LS_QUICK_V1); } catch (e) {}
  }

  /* v13: כיוון הגזרה של הדגם לפי fit_stats.
     shift מפורש (1 = נוטה לקטן / עולים מידה, -1 = רחב / אפשר לרדת, 0 = לפי המידה).
     אם אין שדה shift - נופלים לזיהוי לפי מילות מפתח כמו קודם (תאימות לאחור). */
  function fitShift(fs) {
    if (!fs) return 0;
    if (typeof fs.shift === 'number') return fs.shift > 0 ? 1 : (fs.shift < 0 ? -1 : 0);
    if (fs.tts !== false) return 0;
    var a = String(fs.advice || '');
    if (a.indexOf('קטנה') >= 0 || a.indexOf('לקטן') >= 0) return 1;
    if (a.indexOf('רחבה') >= 0 || a.indexOf('רחב') >= 0) return -1;
    return 0;
  }

  function compute(chart, vals) {
    var m = chart.m, n = chart.sizes.length, sizes = chart.sizes;
    var fields = chart.fields.filter(function (f) { return f !== 'height'; });

    for (var k = 0; k < fields.length; k++) {
      var f = fields[k], v = vals[f];
      if (v == null) continue;
      if (tooHigh(v, m[f]) || tooLow(v, m[f])) {
        return {
          error: 'לפי ' + FIELD_NAMES[f] + ' שהוזן, אין לדגם הזה מידה מתאימה בטבלה.',
          field: f,
          dir: tooHigh(v, m[f]) ? 'above' : 'below'
        };
      }
    }

    var bands = {}, provided = [];
    fields.forEach(function (f) {
      if (vals[f] == null) return;
      bands[f] = bandIndex(vals[f], m[f]);
      provided.push(f);
    });

    var base = 0, minB = n - 1;
    provided.forEach(function (f) {
      if (bands[f] > base) base = bands[f];
      if (bands[f] < minB) minB = bands[f];
    });
    if (provided.length === 1) minB = base;

    var i = base, hint = '';
    var spread = base - minB;

    var edgeAtBase = provided.some(function (f) {
      return bands[f] === base && isUpperEdge(vals[f], m[f]);
    });

    /* v13: ההמלצה תמיד לפי המדד הגדול. חלופה (המידה הקטנה) מוצעת רק כשהיא
       סמוכה - פער של מידה אחת בדיוק - ורק בפריט עליון עם חזה+מותן, בסגנון
       "between sizes" המקובל בענף. פער של שתי מידות ומעלה לא מקבל חלופה. */
    var isBottoms = provided.indexOf('bust') < 0;
    var bustWaistAdjacent = (bands.bust != null && bands.waist != null && bands.bust - bands.waist === 1);
    if (spread >= 2) {
      hint = isBottoms
        ? 'יש פער בין המותן לירכיים - ההמלצה לפי המדד הגדול, למניעת מתיחת יתר ושקיפות.'
        : 'יש פער בין המדדים שלך - ההמלצה לפי החזה, המדד הקובע בפריט עליון. במותן הגזרה תשב מעט רפויה וזה תקין.';
    } else if (spread === 1 && bustWaistAdjacent) {
      hint = 'לפי היקף החזה המידה שלך ' + sizes[base] + ', ולפי המותן ' + sizes[minB] + '. המלצנו על ' + sizes[base] + ' לישיבה נוחה; מעדיפה מראה צמוד יותר? ' + sizes[minB] + ' גם תתאים.';
    } else if (spread === 1) {
      hint = 'המדדים שלך בין ' + sizes[minB] + ' ל-' + sizes[base] + ' - המלצנו על הגדולה.';
    } else if (edgeAtBase && base < n - 1) {
      hint = 'את על הגבול העליון של ' + sizes[base] + ' - מעדיפה גזרה משוחררת יותר? שקלי את ' + sizes[base + 1] + '.';
    }

    /* v13: כלל הגובה באוברול מדורג - 175+ תמיד מידה מעל (הטורסו ארוך יותר),
       170-174 רק כשאחד המדדים בחצי העליון של הטווח או יש פער בין המדדים. */
    var heightBumped = false;
    if (chart.heightRule && vals.height != null && vals.height >= 170) {
      var upperHalf = provided.some(function (f) {
        var R = m[f][bands[f]];
        return vals[f] >= (R[0] + R[1]) / 2;
      });
      var wantUp = vals.height >= 175 || upperHalf || spread > 0;
      if (wantUp && i < n - 1) {
        i += 1; heightBumped = true;
        hint = 'בגובה ' + (vals.height >= 175 ? '175+' : '170+') + ' ההמלצה של הדגם היא מידה אחת מעל, לאורך טורסו נוח - כבר כללנו את זה.';
      } else if (wantUp) {
        hint = (hint ? hint + ' ' : '') + 'בגובה 170+ מומלץ בדרך כלל לעלות מידה, אך זו המידה הגדולה ביותר בדגם.';
      } else if (i < n - 1) {
        hint = (hint ? hint + ' ' : '') + 'בגובה 170-174 ומדדים בתחילת הטווח - המידה הזו תשב טוב; מעדיפה יותר אורך? שקלי את ' + sizes[i + 1] + '.';
      }
    }

    return { idx: clampIdx(i, n), hint: hint, spread: spread, edge: edgeAtBase, heightBumped: heightBumped };
  }

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: 'size_finder_' + name };
      if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) p[k] = data[k]; } }
      window.dataLayer.push(p);
    } catch (e) {}
  }

  function normalizeTables(scope) {
    $$('table', scope).forEach(function (t) {
      var rows = t.rows;
      for (var i = 0; i < rows.length; i++) {
        rows[i].style.background = 'transparent';
        var cells = rows[i].cells;
        for (var j = 0; j < cells.length; j++) {
          var c = cells[j];
          c.style.padding = '9px 6px';
          c.style.textAlign = 'center';
          c.style.border = '0';
          c.style.borderBottom = (i === rows.length - 1) ? '0' : '1px solid #f2f2f2';
          c.style.fontSize = '12.5px';
          if (i === 0) {
            c.style.background = '#111';
            c.style.color = '#fff';
            c.style.fontWeight = '600';
          } else {
            c.style.background = (i % 2 === 0) ? '#fafafa' : '#fff';
            c.style.color = (j === 0) ? '#111' : '#333';
            c.style.fontWeight = (j === 0) ? '600' : '400';
          }
        }
      }
    });
  }

  var activeModal = null;
  var modalReturnFocus = null;
  function closeModal() {
    if (!activeModal) return;
    activeModal.remove();
    activeModal = null;
    document.body.classList.remove('ids-modal-open');
    document.removeEventListener('keydown', onModalKey);
    if (modalReturnFocus && typeof modalReturnFocus.focus === 'function') {
      try { modalReturnFocus.focus(); } catch (e) {}
    }
    modalReturnFocus = null;
  }
  function focusableIn(container) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),video[controls],[tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(container.querySelectorAll(sel)).filter(function (el) {
      return el.offsetParent !== null || getComputedStyle(el).position === 'fixed';
    });
  }
  function onModalKey(e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab' || !activeModal) return;
    var card = activeModal.querySelector('.ids-modal__card');
    if (!card) return;
    var f = focusableIn(card);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }
  function openModal(srcEl) {
    closeModal();
    modalReturnFocus = document.activeElement;
    var title = srcEl.getAttribute('data-title') || '';
    var modal = document.createElement('div');
    modal.className = 'ids-modal';
    modal.setAttribute('dir', 'rtl');
    modal.innerHTML =
      '<div class="ids-modal__bg"></div>' +
      '<div class="ids-modal__card" role="dialog" aria-modal="true">' +
        '<div class="ids-modal__head"><span></span>' +
          '<button type="button" class="ids-modal__x" aria-label="סגירה">' +
            '<svg width="14" height="14" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ids-modal__body"></div>' +
      '</div>';
    modal.querySelector('.ids-modal__head span').textContent = title;
    var body = modal.querySelector('.ids-modal__body');
    body.innerHTML = srcEl.innerHTML;
    normalizeTables(body);
   var vid = body.querySelector('[data-ids="measurevid"]');
    var playBtn = body.querySelector('[data-ids="measureplay"]');
    if (vid && !vid.src) {
      var mp4 = vid.getAttribute('data-mp4');
      var mov = vid.getAttribute('data-mov');
      var src = '';
      if (mp4 && mp4.indexOf('REPLACE_WITH') < 0 && vid.canPlayType && vid.canPlayType('video/mp4')) {
        src = mp4;
      } else if (mov) {
        src = mov;
      } else if (mp4 && mp4.indexOf('REPLACE_WITH') < 0) {
        src = mp4;
      }
      if (src) {
        vid.src = src;
        var p = vid.play();
        if (p && p.catch) {
          p.catch(function () { if (playBtn) playBtn.hidden = false; });
        }
      }
    }
    if (playBtn && vid) {
      playBtn.addEventListener('click', function () {
        var pp = vid.play();
        if (pp && pp.then) { pp.then(function () { playBtn.hidden = true; }).catch(function () {}); }
        else { playBtn.hidden = true; }
      });
    }
    var toChart = body.querySelector('[data-ids="measure-to-chart"]');
    if (toChart) {
      toChart.addEventListener('click', function () {
        var host = srcEl.closest('.ids-fms') || document;
        var chartEl = host.querySelector('[data-ids="chartsrc"]');
        closeModal();
        if (chartEl) openModal(chartEl);
      });
    }
    modal.querySelector('.ids-modal__bg').addEventListener('click', closeModal);
    modal.querySelector('.ids-modal__x').addEventListener('click', closeModal);
   document.body.appendChild(modal);
    document.body.classList.add('ids-modal-open');
    document.addEventListener('keydown', onModalKey);
    activeModal = modal;
    var closeX = modal.querySelector('.ids-modal__x');
    if (closeX && closeX.focus) { try { closeX.focus(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.id-fit__video-link');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var host = link.closest('product-info') || document.querySelector('product-info.idpdp-v2') || document;
    var source = host.querySelector('[data-ids="measuresrc"]');
    if (!source) return;
    e.preventDefault();
    openModal(source);
  });

  function escAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  var reopenNext = false;

  function initWidget(root) {
    if (root.dataset.idsReady === 'true') return;
    if (!root.hasAttribute('data-chart')) return;
    root.dataset.idsReady = 'true';

    var chartKey = root.getAttribute('data-chart') || 'auto';
    var detailsEl = root.closest('details');

    var typeSeg = $('[data-ids="typeseg"]', root);
    var promptEl = $('[data-ids="prompt"]', root);
    var errorEl = $('[data-ids="error"]', root);
    var outEl = $('[data-ids="out"]', root);
    var chartSrc = $('[data-ids="chartsrc"]', root);
    var measureSrc = $('[data-ids="measuresrc"]', root);
    if (measureSrc) document.documentElement.classList.add('id-fit-video-ready');
    var chartToggle = $('[data-ids="charttoggle"]', root);
    var measureBtn = $('[data-ids="measure"]', root);
    var clearBtn = $('[data-ids="clear"]', root);

    var sumTitle = detailsEl ? $('[data-ids="sumtitle"]', detailsEl) : null;
    var sumEdit = detailsEl ? $('[data-ids="sumedit"]', detailsEl) : null;

    var quickEl = $('[data-ids="quick"]', root);
    var preciseEl = $('[data-ids="precise"]', root);
    var usualTopEl = $('[data-ids="usual-top"]', root);
    var usualBottomEl = $('[data-ids="usual-bottom"]', root);
    var qUsualTop = $('[data-ids="q-usual-top"]', root);
    var qUsualBottom = $('[data-ids="q-usual-bottom"]', root);
    var fitEl = $('[data-ids="fit"]', root);
    var qFitEl = $('[data-ids="q-fit"]', root);
    var stepBackEl = $('[data-ids="stepback"]', root);
    var pathTabsEl = $('[data-ids="pathtabs"]', root);
    var inputAreaEl = $('[data-ids="inputarea"]', root);
    var inputSumEl = $('[data-ids="inputsum"]', root);
    var inputSumTxt = $('[data-ids="inputsum-txt"]', root);

    var inputs = {
      bust: $('[data-ids="bust"]', root), waist: $('[data-ids="waist"]', root),
      hips: $('[data-ids="hips"]', root), height: $('[data-ids="height"]', root)
    };

    var timer = null;
    var pickBusy = false;
    var lastSize = null;
    var lastErrKey = null;
    var suppressOpenTrack = false;
    var userInteracted = false;
    var currentRec = null;
    var manualOverride = false;
    var activePath = 'precise';
    var currentCat = 'top';
    var quickUsual = null;
    var quickFit = 'true';
    var quickStep = 1;
    var typeSegActive = false;
    var recPillEl = null;
    var autoClosedAfterRecommend = false;
    var recommendCloseTimer = null;
    var contactUrl = root.getAttribute('data-contact') || '/pages/contact';
    function markInteracted() { userInteracted = true; }

    var fitAdviceEl = document.querySelector('[data-ids="fitadvice"]');

    var fitStats = null;
    var fsRaw = root.getAttribute('data-fitstats');
    if (fsRaw) { try { fitStats = JSON.parse(fsRaw); } catch (e) { fitStats = null; } }

    var variantsMap = null;
    var vSrc = $('[data-ids="variants"]', root);
    if (vSrc) { try { variantsMap = JSON.parse(vSrc.textContent); } catch (e) { variantsMap = null; } }

    function isVisible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function sizePickerScope() {
      return root.closest('.product__info-container') ||
             root.closest('product-info') ||
             root.closest('.product') ||
             root.closest('.shopify-section') ||
             document;
    }

    function sizePickerGroups() {
      var scope = sizePickerScope();
      var groups = [];
      $$('input[type="radio"]', scope).forEach(function (radio) {
        if (radio.closest('.ids-fms')) return;
        if (radio.closest('[class*="pcard"], [class*="product-card"], [class*="card-product"], [class*="complementary"], [class*="related"], sticky-atc-bar')) return;
        if (chart().sizes.indexOf((radio.value || '').trim().toUpperCase()) < 0) return;
        var group = radio.closest('fieldset') ||
                    radio.closest('.product-form__input') ||
                    radio.closest('[class*="variant"]') ||
                    radio.closest('[class*="option"]') ||
                    radio.parentElement;
        if (!group || group.closest('.ids-fms')) return;
        if (groups.indexOf(group) < 0) groups.push(group);
      });
      return groups.filter(function (group) {
        if (!isVisible(group)) return false;
        var values = $$('input[type="radio"]', group).map(function (r) {
          return (r.value || '').trim().toUpperCase();
        }).filter(function (v) { return chart().sizes.indexOf(v) >= 0; });
        return values.length >= 2;
      });
    }

    function primarySizePickerGroup() {
      var groups = sizePickerGroups();
      if (!groups.length) return null;
      if (groups.length === 1) return groups[0];
      var detailsBox = detailsEl ? detailsEl.getBoundingClientRect() : null;
      if (!detailsBox) return groups[0];
      var before = groups.filter(function (g) { return g.getBoundingClientRect().top < detailsBox.top; });
      return before.length ? before[0] : groups[0];
    }

    function dedupeSizePickers() {
      var groups = sizePickerGroups();
      if (groups.length < 2) return;
      var keep = primarySizePickerGroup() || groups[0];
      var keepValues = $$('input[type="radio"]', keep).map(function (r) {
        return (r.value || '').trim().toUpperCase();
      }).filter(function (v) { return chart().sizes.indexOf(v) >= 0; }).sort().join('|');
      groups.forEach(function (g) {
        if (g === keep) return;
        var values = $$('input[type="radio"]', g).map(function (r) {
          return (r.value || '').trim().toUpperCase();
        }).filter(function (v) { return chart().sizes.indexOf(v) >= 0; }).sort().join('|');
        if (values && values === keepValues) {
          g.setAttribute('hidden', '');
          g.style.setProperty('display', 'none', 'important');
          g.setAttribute('data-ids-hidden-duplicate', 'true');
        }
      });
    }

    function placeFitAdviceInline() {
      if (!fitAdviceEl) return;
      var group = primarySizePickerGroup();
      if (!group) return;
      var target = group.querySelector('legend') ||
                   group.querySelector('.form__label') ||
                   group.querySelector('label') ||
                   group;
      if (!target || target.contains(fitAdviceEl)) return;
      fitAdviceEl.classList.remove('ids-fitadvice--pending');
      fitAdviceEl.classList.add('ids-fitadvice--inline');
      target.appendChild(fitAdviceEl);
    }

    root.__idsMaintain = function () {
      dedupeSizePickers();
      placeFitAdviceInline();
      refreshAtcLabel();
      syncPickerAlt();
      if (currentRec && !manualOverride) {
        autoSelectSize(currentRec);
        injectRecPillFor(currentRec);
      }
    };

    if (chartKey === 'auto') {
      typeSegActive = true;
      if (typeSeg) typeSeg.removeAttribute('hidden');
      chartKey = 'top_std';
      if (typeSeg) {
        $$('[data-qtype]', typeSeg).forEach(function (btn) {
          btn.addEventListener('click', function () {
            markInteracted();
            $$('[data-qtype]', typeSeg).forEach(function (b) { b.classList.toggle('on', b === btn); });
            chartKey = (btn.getAttribute('data-qtype') === 'bottom') ? 'bottom_std' : 'top_std';
            quickUsual = null; lastSize = null;
            applyChart(); applyMode(); recalc();
          });
        });
      }
    }

    function chart() { return CHARTS[chartKey]; }

    function applyChart() {
      var c = chart();
      $$('.ids-field[data-f]', root).forEach(function (fEl) {
        var f = fEl.getAttribute('data-f');
        if (c.fields.indexOf(f) >= 0) fEl.removeAttribute('hidden');
        else fEl.setAttribute('hidden', '');
      });
      var waistLabel = $('[data-ids="waist-label"]', root);
      if (waistLabel) {
        waistLabel.textContent = (c.optional && c.optional.indexOf('waist') >= 0)
          ? 'היקף מותן - לא חובה'
          : 'היקף מותן (ס"מ)';
      }
      var vis = c.fields.filter(function (f) { return inputs[f]; });
      vis.forEach(function (f, i) {
        inputs[f].setAttribute('enterkeyhint', i === vis.length - 1 ? 'done' : 'next');
      });
    }

    function applyMode() {
      currentCat = (chartKey === 'bottom_std' || chartKey === 'bottom_xs_l') ? 'bottom' : 'top';
      /* v13: בעת מעבר קטגוריה (טופ/טייץ בדגם auto) טוענים את המידה השמורה של הקטגוריה */
      if (activePath === 'quick' && !quickUsual) {
        var sq = loadQuick(currentCat);
        if (sq.usual) { quickUsual = String(sq.usual).toUpperCase(); quickFit = sq.fit === 'relaxed' ? 'relaxed' : quickFit; }
      }
      buildSizeChips();
      applyQuickStep();
    }

    /* v13: צ'יפ XS וירטואלי בדגמים שמתחילים מ-S (למשל HERA קרופ טופ) -
       לקוחה שרגילה ל-XS מקבלת את המידה הראשונה של הדגם + הסבר */
    function quickChipSizes() {
      var sizes = chart().sizes.slice();
      if (sizes[0] !== 'XS') sizes.unshift('XS');
      return sizes;
    }

    /* wizard: show one step at a time on the quick path (size -> fit -> result) */
    function applyQuickStep() {
      var onQuick = (activePath === 'quick');
      if (qUsualTop) qUsualTop.hidden = !(onQuick && currentCat === 'top' && quickStep === 1);
      if (qUsualBottom) qUsualBottom.hidden = !(onQuick && currentCat === 'bottom' && quickStep === 1);
      if (qFitEl) qFitEl.hidden = !(onQuick && quickStep === 2);
      if (typeSeg && typeSegActive) typeSeg.hidden = !(onQuick && quickStep === 1);
    }

    function buildSizeChips() {
      var sizes = quickChipSizes();
      var container = (currentCat === 'bottom') ? usualBottomEl : usualTopEl;
      [usualTopEl, usualBottomEl].forEach(function (c) { if (c) c.innerHTML = ''; });
      if (!container) return;
      if (quickUsual && sizes.indexOf(quickUsual) < 0) quickUsual = null;
      sizes.forEach(function (sz) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ids-chip2' + (sz === quickUsual ? ' sel' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', sz === quickUsual ? 'true' : 'false');
        b.setAttribute('data-size', sz);
        b.textContent = sz;
        b.addEventListener('click', function () { markInteracted(); selectUsual(sz, container); });
        container.appendChild(b);
      });
    }
    function selectUsual(sz, container) {
      quickUsual = sz;
      saveQuick(currentCat, quickUsual, quickFit);
      $$('.ids-chip2', container).forEach(function (b) {
        var on = b.getAttribute('data-size') === sz;
        b.classList.toggle('sel', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      /* v13.1: שלב 2 - שאלת הגזרה לפני התוצאה */
      quickStep = 2;
      buildFitChips();
      applyQuickStep();
    }

    function buildFitChips() {
      if (!fitEl) return;
      fitEl.innerHTML = '';
      FITS.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ids-chip2' + (o.v === quickFit ? ' sel' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', o.v === quickFit ? 'true' : 'false');
        b.setAttribute('data-fit', o.v);
        b.textContent = o.label;
        b.addEventListener('click', function () { markInteracted(); selectFit(o.v); });
        fitEl.appendChild(b);
      });
    }
    function selectFit(v) {
      quickFit = v;
      if (quickUsual) saveQuick(currentCat, quickUsual, quickFit);
      $$('.ids-chip2', fitEl).forEach(function (b) {
        var on = b.getAttribute('data-fit') === v;
        b.classList.toggle('sel', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      recalc();
    }

   function setPath(p) {
      activePath = p;
      quickStep = 1;
      restorePicker();
      applyPathClass();
      if (quickEl) quickEl.hidden = (p !== 'quick');
      if (preciseEl) preciseEl.hidden = (p !== 'precise');
      applyQuickStep();
      var pPrecise = pathTabsEl ? $('[data-path="precise"]', pathTabsEl) : null;
      var pQuick = pathTabsEl ? $('[data-path="quick"]', pathTabsEl) : null;
      if (pPrecise) pPrecise.hidden = (p === 'precise');
      if (pQuick) pQuick.hidden = (p === 'quick');
      lastSize = null;
      updateSummary(null);
      hideOut();
      recalc();
    }
    if (pathTabsEl) {
      $$('[data-path]', pathTabsEl).forEach(function (btn) {
        btn.addEventListener('click', function () { markInteracted(); setPath(btn.getAttribute('data-path')); });
      });
    }

    function setInputSum(text) {
      if (inputSumTxt) inputSumTxt.textContent = text;
      if (inputAreaEl) inputAreaEl.hidden = true;
      if (pathTabsEl) pathTabsEl.hidden = true;
      if (inputSumEl) inputSumEl.hidden = true; /* v13.3: הגלולה בתוצאה היא נקודת העריכה */
    }
   function expandInputs() {
      restorePicker();
      if (inputAreaEl) inputAreaEl.hidden = false;
      if (pathTabsEl) pathTabsEl.hidden = false;
      if (inputSumEl) inputSumEl.hidden = true;
      if (outEl) { outEl.setAttribute('hidden', ''); outEl.innerHTML = ''; }
      root.classList.remove('ids-has-result');
      lastSize = null;
      clearRecPill();
      updateSummary(null);
      if (activePath === 'quick') {
        quickStep = 1;
        applyQuickStep();
      }
      applyPathClass();
    }
    function applyPathClass() {
      root.classList.toggle('ids-path-quick', activePath === 'quick');
      root.classList.toggle('ids-path-precise', activePath === 'precise');
    }
    if (inputSumEl) inputSumEl.addEventListener('click', expandInputs);
    if (stepBackEl) stepBackEl.addEventListener('click', function () { quickStep = 1; applyQuickStep(); });

   function renderSummary() {
      if (!sumTitle) return;
      var isOpen = detailsEl && detailsEl.open;
      if (currentRec && !isOpen) {
        sumTitle.innerHTML = escAttr(root.getAttribute('data-recommended-label') || 'מומלץ לך:') + ' <strong>' + escAttr(currentRec) + '</strong>';
        if (sumEdit) sumEdit.hidden = false;
      } else if (currentRec && isOpen) {
        sumTitle.textContent = 'המידה המומלצת';
        if (sumEdit) sumEdit.hidden = true;
      } else {
        sumTitle.textContent = DEFAULT_SUMTITLE;
        if (sumEdit) sumEdit.hidden = true;
      }
    }
    function updateSummary(sizeLabel) { currentRec = sizeLabel; renderSummary(); }
    function scheduleRecommendClose() {
      /* סגירה אוטומטית בוטלה לבקשת המשתמשת - הכרטיס נשאר פתוח עד שהמבקרת סוגרת אותו. */
      return;
    }
    if (detailsEl) {
      detailsEl.addEventListener('toggle', function () {
        renderSummary();
        if (detailsEl.open) {
          if (suppressOpenTrack) { suppressOpenTrack = false; return; }
          track('open', { chart: chartKey });
        }
      });
    }

    /* v13.1: כשמאפסים/מחליפים מסלול, הבורר חוזר למידה שהייתה מסומנת לפני
       שהמחשבון בחר אוטומטית (אלא אם הלקוחה בחרה ידנית בינתיים). */
    var initialPicked = null;
    function rememberInitialPicked() {
      if (initialPicked !== null) return;
      var g = primarySizePickerGroup();
      var r = g ? $$('input[type="radio"]', g).filter(function (x) { return x.checked; })[0] : null;
      initialPicked = r ? (r.value || '').trim().toUpperCase() : '';
    }
    function restorePicker() {
      if (!currentRec || manualOverride || !initialPicked) return;
      var cur = currentSelectedSize();
      if (cur === initialPicked || cur !== currentRec) return;
      var r = findSizeInput(initialPicked);
      if (!r || r.checked) return;
      preserveScroll(function () {
        r.click();
        if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      var exp = variantsMap ? variantsMap[initialPicked] : null;
      if (exp) { var idEl = formIdEl(); if (idEl) idEl.value = exp.id; syncStickyBar(exp); }
      syncSizeLabelText(r, initialPicked);
    }
    function findSizeInput(sizeLabel) {
      var group = primarySizePickerGroup();
      var radios = group ? $$('input[type="radio"]', group) : $$('input[type="radio"]', sizePickerScope());
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].closest('.ids-fms')) continue;
        if (!isVisible(radios[i]) && !isVisible(radios[i].closest('label'))) continue;
        if (radios[i].closest('[class*="pcard"], [class*="product-card"], [class*="card-product"], [class*="complementary"], [class*="related"]')) continue;
        var v = (radios[i].value || '').trim().toUpperCase();
        if (v === sizeLabel) return radios[i];
      }
      return null;
    }
    function syncSizeLabelText(r, sizeLabel) {
      if (!r) return;
      var fs = r.closest('fieldset') || r.closest('.product-form__input');
      var lab = fs ? fs.querySelector('[data-selected-swatch-value]') : null;
      if (lab && lab.textContent !== sizeLabel) lab.textContent = sizeLabel;
    }
    function preserveScroll(fn) {
      var x = window.scrollX, y = window.scrollY;
      var cancelled = false;
      function cancel() { cancelled = true; }
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
        window.addEventListener(ev, cancel, { passive: true, once: true });
      });
      fn();
      [0, 60, 180, 420].forEach(function (ms) {
        setTimeout(function () { if (!cancelled) window.scrollTo(x, y); }, ms);
      });
    }
    /* v12.1 — התיקון: הבחירה האוטומטית עוברת תמיד דרך click() אמיתי
       (עם dispatch של change כגיבוי), גם לפני אינטראקציה של המשתמשת.
       הסימון השקט הקודם (r.checked = true בלי אירוע) יצר פער בין
       מה שרואים (M) לבין ה-state של התמה (הווריאנט הראשון, XS) —
       וכל ההוספות לסל נכנסו בווריאנט הראשון. */
    function autoSelectSize(sizeLabel) {
      rememberInitialPicked();
      dedupeSizePickers();
      placeFitAdviceInline();
      var r = findSizeInput(sizeLabel);
      var expected = variantsMap ? variantsMap[sizeLabel] : null;
      if (expected && expected.available === false) return;
      if (!r) return;

      if (r.checked) {
        /* הרדיו כבר נכון — מוודאים שגם הטופס וה-sticky bar מסונכרנים
           (הגנה מפני רינדור-מחדש של התמה שדורס את input[name=id]) */
        if (expected) {
          var idEl0 = formIdEl();
          if (idEl0 && String(idEl0.value) !== String(expected.id)) idEl0.value = expected.id;
          syncStickyBar(expected);
        }
        syncSizeLabelText(r, sizeLabel);
        return;
      }

      if (detailsEl && detailsEl.open) reopenNext = true;
      preserveScroll(function () {
        r.click(); /* בחירה אמיתית — התמה מעדכנת state, מחיר, טופס ו-URL */
        if (!r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (expected) {
        var idEl = formIdEl();
        if (idEl) idEl.value = expected.id;
        syncStickyBar(expected);
      }
      syncSizeLabelText(r, sizeLabel);
      setTimeout(function () {
        dedupeSizePickers();
        placeFitAdviceInline();
      }, 80);
    }
    function setRecProperty(sizeLabel) {
      var forms = [];
      var f = mainForm();
      if (f) forms.push(f);
      var stickyForms = document.querySelectorAll('sticky-atc-bar form[action*="/cart/add"]');
      for (var sfi = 0; sfi < stickyForms.length; sfi++) {
        if (forms.indexOf(stickyForms[sfi]) < 0) forms.push(stickyForms[sfi]);
      }
      forms.forEach(function (fm) {
        var old = fm.querySelector('[data-ids-recprop]');
        if (old) old.remove();
        if (!sizeLabel) return;
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[_size_finder]';
        inp.value = sizeLabel + (activePath === 'quick' ? ' · שאלון' : ' · מדידה');
        inp.setAttribute('data-ids-recprop', '');
        fm.appendChild(inp);
      });
      if (sizeLabel) {
        var recVal = sizeLabel + (activePath === 'quick' ? ' · שאלון' : ' · מדידה');
        var recIds = {};
        if (variantsMap) {
          for (var vk in variantsMap) {
            if (variantsMap.hasOwnProperty(vk) && variantsMap[vk] && variantsMap[vk].id) recIds[String(variantsMap[vk].id)] = true;
          }
        }
        window.__idsActiveRec = { value: recVal, ids: recIds };
        syncCartAttr(recVal);
      } else {
        window.__idsActiveRec = null;
      }
    }
    function syncCartAttr(val) {
      try {
        var mh = location.pathname.match(/\/products\/([^\/?]+)/);
        var full = val + (mh ? ' · ' + mh[1] : '');
        if (sessionStorage.getItem('ids_cart_attr') === full) return;
        sessionStorage.setItem('ids_cart_attr', full);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_size_finder_last': full } })
        }).catch(function () {});
      } catch (e) {}
    }
    function mainForm() {
      var sectionEl = root.closest('.shopify-section') || document;
      return sectionEl.querySelector('form[action*="/cart/add"]');
    }
    function syncStickyBar(expected, attempt) {
      if (!expected) return;
      var sels = document.querySelectorAll('sticky-atc-bar [name="id"]');
      if (!sels.length) {
        if ((attempt || 0) < 5) {
          setTimeout(function () { syncStickyBar(expected, (attempt || 0) + 1); }, 300);
        }
        return;
      }
      for (var i = 0; i < sels.length; i++) { sels[i].value = String(expected.id); }
    }
    function formIdEl() {
      var f = mainForm();
      return f ? f.querySelector('[name="id"]') : null;
    }
    function formVariantOk(expected) {
      if (!expected) return null;
      var idEl = formIdEl();
      if (!idEl) return null;
      return String(idEl.value) === String(expected.id);
    }
    function findAtcButton() {
      var sectionEl = root.closest('.shopify-section') || document;
      return sectionEl.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
             sectionEl.querySelector('form[action*="/cart/add"] [name="add"]') ||
             sectionEl.querySelector('button[name="add"]') ||
             sectionEl.querySelector('.product-form__submit');
    }
    function isDisabled(btn) {
      return !btn || btn.disabled ||
             btn.getAttribute('aria-disabled') === 'true' ||
             btn.classList.contains('disabled');
    }
    function scrollToPicker() {
      var r = lastSize ? findSizeInput(lastSize) : null;
      var t = r ? (r.closest('fieldset') || r.closest('.product-form__input') || r) : null;
      if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function selectSizeForNotify(sizeLabel) {
      var r = findSizeInput(sizeLabel);
      if (!r || r.checked) return;
      r.click();
      if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    var desiredAtcText = null;
    function atcLabelEl(btn) {
      if (!btn) return null;
      var spans = btn.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        var t = (spans[i].textContent || '').trim();
        if (t && spans[i].children.length === 0) return spans[i];
      }
      return btn;
    }
    function currentSelectedSize() {
      var g = primarySizePickerGroup();
      if (!g) return null;
      var radios = $$('input[type="radio"]', g);
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          var v = (radios[i].value || '').trim().toUpperCase();
          if (chart().sizes.indexOf(v) >= 0) return v;
        }
      }
      return null;
    }
    function refreshAtcLabel() {
      /* עדכון טקסט הכפתור בוטל לבקשת המשתמשת - הכפתור נשאר עם הטקסט של התמה. */
      desiredAtcText = null;
    }
    function refreshAtcLabelSoon() {
      refreshAtcLabel();
      setTimeout(refreshAtcLabel, 120);
      setTimeout(refreshAtcLabel, 400);
    }

    function clearRecPill() {
      var sectionEl = root.closest('.shopify-section') || document;
      $$('.ids-rec-pill[data-ids-recpill]', sectionEl).forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      recPillEl = null;
    }
    function injectRecPillFor(sizeLabel) {
      /* תווית "מומלץ" הוסרה לבקשת המשתמשת - מיותרת (כבר מסומן בכל מקום). */
      clearRecPill();
    }

    function fitFeedbackHTML() {
      if (!fitStats) return '';
      var s = +fitStats.small || 0, t = +fitStats['true'] || 0, l = +fitStats.large || 0;
      var tot = s + t + l;
      if (tot < 5) return '';
      function pct(x) { return Math.round(x / tot * 100); }
      var note = (fitStats.note && String(fitStats.note).trim()) ? String(fitStats.note).trim() : '';
      var msg, dom;
      if (s >= l && s >= t)     { msg = pct(s) + '% מהבנות העדיפו לעלות מידה'; dom = 'up'; }
      else if (l > s && l >= t) { msg = pct(l) + '% מהבנות העדיפו לרדת מידה'; dom = 'down'; }
      else                      { msg = pct(t) + '% ציינו שהמידה מדויקת';     dom = 'true'; }
      return '' +
        '<div class="ids-fitdetail" data-ids="fitdetail">' +
          '<span class="ids-fitbar">' +
            '<i class="' + (dom === 'up' ? 'dom' : '') + '"></i>' +
            '<i class="' + (dom === 'true' ? 'dom' : '') + '"></i>' +
            '<i class="' + (dom === 'down' ? 'dom' : '') + '"></i>' +
          '</span>' +
          '<span>' + (note ? '<b>' + escAttr(note) + '</b> · ' : '') + msg + ' <em>(מתוך ' + tot + ' ביקורות על הדגם)</em></span>' +
        '</div>';
    }

    function readVals() {
      var vals = {};
      Object.keys(inputs).forEach(function (f) {
        var el = inputs[f];
        if (!el) return;
       var v = (typeof el.valueAsNumber === 'number' && !isNaN(el.valueAsNumber)) ? el.valueAsNumber : parseFloat(el.value);
        if (isNaN(v)) return;
        v = Math.round(v);
        var minPlausible = (f === 'height') ? 100 : 40;
        if (v < minPlausible) return;
        vals[f] = v;
      });
      return vals;
    }

    function hideOut() {
      root.classList.remove('ids-has-result');
      outEl.setAttribute('hidden', '');
      outEl.innerHTML = '';
      expandInputs();
      setRecProperty(null);
      clearRecPill();
    }

    var altCache = {};
    var altCurrentTitle = '';
    function loadAlts(sizeLabel, targetBox, labelText) {
      var box = targetBox || $('[data-ids="alt"]', outEl);
      if (!box || !window.fetch) return;
      var m = location.pathname.match(/\/products\/([^\/?]+)/);
      var curHandle = m ? m[1] : null;
      if (!curHandle) return;
      if (altCache[sizeLabel]) { renderAlts(box, sizeLabel, altCache[sizeLabel], labelText); return; }
      if (loadAlts.__busy && loadAlts.__busy[sizeLabel]) return;
      loadAlts.__busy = loadAlts.__busy || {};
      loadAlts.__busy[sizeLabel] = true;
      var TYPE_COLL = {
        'GYM LEGGINGS': 'leggings',
        'GYM SHORT': 'shorts',
        'GYM TOP': 'tops',
        'shirt': '\u05d7\u05d5\u05dc\u05e6\u05d5\u05ea',
        'jacket': 'shirts',
        'jumpsuit': 'jumpsuits'
      };
      altJSON('/products/' + curHandle + '.js')
        .then(function (p) {
          altCurrentTitle = p.title || '';
          var coll = TYPE_COLL[p.type];
          if (!coll) return null;
          return Promise.all([
            altJSON('/collections/' + encodeURIComponent(coll) + '/products.json?limit=50'),
            altJSON('/collections/popular-now/products.json?limit=50').catch(function () { return { products: [] }; })
          ]);
        })
        .then(function (res) {
          if (!res) return;
          var prods = res[0].products || [];
          var rank = {};
          (res[1].products || []).forEach(function (pp, i) { rank[pp.id] = i; });
          var out = [];
          prods.forEach(function (pp) {
            if (pp.handle === curHandle) return;
            var v = null;
            (pp.variants || []).forEach(function (vv) {
              if (v || !vv.available) return;
              var t = String(vv.title || '').toUpperCase();
              if (t === sizeLabel || t.split(' / ').indexOf(sizeLabel) >= 0 || String(vv.option1 || '').toUpperCase() === sizeLabel) v = vv;
            });
            if (!v) return;
            var img = (pp.images && pp.images[0] && pp.images[0].src) || '';
            if (!img) return;
            out.push({ handle: pp.handle, title: pp.title, img: img, vid: v.id, r: (rank[pp.id] != null ? rank[pp.id] : 999) });
          });
          out.sort(function (a, b) { return a.r - b.r; });
          // Keep candidates until the picker filters to this model's colours.
          altCache[sizeLabel] = out;
          renderAlts(box, sizeLabel, out, labelText);
        })
        .catch(function () {})
        .finally(function () { delete loadAlts.__busy[sizeLabel]; });
    }
    function renderAlts(box, sizeLabel, list, labelText) {
      // A catalogue response may arrive after the shopper has changed size.
      if (box && box.classList.contains('ids-alt-picker')) {
        var selected = selectedSizeRadio();
        var currentSize = selected ? selected.value.trim().toUpperCase() : null;
        var currentVariant = variantsMap && variantsMap[currentSize];
        if (currentSize !== sizeLabel || !currentVariant || currentVariant.available !== false) return;
        var picker = box.closest('variant-selects');
        if (picker) picker.querySelectorAll('[data-ids-lowstock]').forEach(function(note){ note.hidden = true; });
      }
      if (box.classList.contains('ids-alt-picker')) {
        var parts = altCurrentTitle.split(' - ');
        var family = parts[0].trim().split(/\s+/)[0];
        var model = parts.slice(1).join(' - ');
        list = (list || []).filter(function(it) {
          var other = it.title.split(' - ');
          return model && other.slice(1).join(' - ') === model && other[0].trim().split(/\s+/)[0] === family;
        }).slice(0, 3);
        if (!list.length || !box.isConnected) { box.hidden = true; return; }
        box.innerHTML = '<div class="ids-alt-heading">זמין במידה <bdi>' + escAttr(sizeLabel) + '</bdi> בצבעים נוספים</div><div class="ids-alt-colours">' +
          list.map(function(it) {
            var colour = it.title.split(' - ')[0].trim().split(/\s+/).slice(1).join(' ');
            var src = it.img + (it.img.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
            return '<a href="/products/' + it.handle + '?variant=' + it.vid + '" aria-label="' + escAttr(it.title + ' · ' + sizeLabel) + '"><img src="' + escAttr(src) + '" width="40" height="50" alt="" loading="lazy"><span dir="auto">' + escAttr(colour) + '</span></a>';
          }).join('') + '</div>';
        box.hidden = false;
        return;
      }
      list = (list || []).slice(0, 3);
      if (!list || !list.length || !box.isConnected) { if (box) box.setAttribute('hidden', ''); return; }
      var h = '<span style="font-size:13px;color:#777;">' + (labelText || (escAttr(sizeLabel) + ' \u05d6\u05de\u05d9\u05e0\u05d4 \u05d1\u05d3\u05d2\u05de\u05d9\u05dd \u05d3\u05d5\u05de\u05d9\u05dd:')) + '</span>';
      list.forEach(function (it) {
        var isrc = it.img + (it.img.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
        h += '<a href="/products/' + it.handle + '?variant=' + it.vid + '" title="' + escAttr(it.title) + '"' +
          ' style="display:inline-block;width:38px;height:38px;border-radius:50%;overflow:hidden;border:1px solid #e2e2e2;flex:0 0 auto;">' +
          '<img src="' + isrc + '" alt="' + escAttr(it.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;"></a>';
      });
      box.innerHTML = h;
      box.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;margin-top:8px;flex-wrap:wrap;';
      box.removeAttribute('hidden');
      track('alt_shown', { size: sizeLabel, count: list.length });
    }

    function pickerAltBox() {
      var scope = sizePickerScope();
      var help = scope.querySelector('.idpdp-size-help');
      var picker = primarySizePickerGroup();
      var anchor = help ? (help.closest('.product__block') || help) : (picker && picker.closest('.product__block'));
      if (!anchor) return null;
      var box = scope.querySelector('.ids-alt-picker');
      if (!box) {
        box = document.createElement('div');
        box.className = 'ids-alt-picker ids-alt-cards';
        box.hidden = true;
        box.setAttribute('dir', 'rtl');
      }
      if (anchor.nextElementSibling !== box) anchor.after(box);
      return box;
    }
    var pickerAltShownFor = null;
    function showPickerAlt(sizeLabel) {
      var box = pickerAltBox();
      if (!box) return;
      var isNew = pickerAltShownFor !== sizeLabel;
      if (!isNew && !box.hasAttribute('hidden') && box.childNodes.length) return;
      if (isNew) box.hidden = true;
      pickerAltShownFor = sizeLabel;
      loadAlts(sizeLabel, box, escAttr(sizeLabel) + ' \u05d0\u05d6\u05dc\u05d4 \u05db\u05d0\u05df \u00b7 \u05d6\u05de\u05d9\u05e0\u05d4 \u05d1:');
      if (isNew) track('picker_alt', { size: sizeLabel });
    }
    function hidePickerAlt() {
      pickerAltShownFor = null;
      var box = sizePickerScope().querySelector('.ids-alt-picker');
      if (box) box.hidden = true;
    }
    function selectedSizeRadio() {
      var g = primarySizePickerGroup();
      if (!g) return null;
      var rs = $$('input[type="radio"]', g);
      for (var ri = 0; ri < rs.length; ri++) { if (rs[ri].checked) return rs[ri]; }
      return null;
    }
    function syncPickerAlt() {
      if (!variantsMap) return;
      var selR = selectedSizeRadio();
      if (!selR) return;
      var sv = (selR.value || '').trim().toUpperCase();
      if (chart().sizes.indexOf(sv) < 0) return;
      var vm = variantsMap[sv];
      if (vm && vm.available === false) showPickerAlt(sv);
      else hidePickerAlt();
    }

    var resultAnimation = null;
    function renderResult(sizeLabel, reasonMain, confident) {
      var expected = variantsMap ? variantsMap[sizeLabel] : null;
      var soldOut = !!(expected && expected.available === false);

      var hasPicker = !!findSizeInput(sizeLabel);
      /* v13.3: תשובה אחת בתוך גלולה אפורה - בלי כפילות ובלי בלוק M גדול */
      var html = '' +
        '<button type="button" class="ids-recpill2" data-ids="recedit">' +
          '<span>המידה שלך: <b>' + escAttr(sizeLabel) + '</b></span>' +
          '<span class="ids-recpill2__edit">לשינוי</span>' +
        '</button>';
      if (reasonMain) html += '<div class="ids-reasons"><p class="main">' + reasonMain + '</p></div>';
      if (soldOut) html += '<p class="ids-soldout-note">\u05d4\u05de\u05d9\u05d3\u05d4 \u05d0\u05d6\u05dc\u05d4</p><div class="ids-alt" data-ids="alt" hidden></div>';
      if (!hasPicker && expected && !soldOut) {
        html += '<button type="button" class="ids-pick" data-ids="pick" data-size="' + escAttr(sizeLabel) + '">\u05d4\u05d5\u05e1\u05e4\u05d4 \u05dc\u05e1\u05dc \u00b7 \u05de\u05d9\u05d3\u05d4 ' + escAttr(sizeLabel) + '</button>';
     }
      /* v13: הסימון מוצג רק כשהמסלול המדויק מאשר התאמה (ראו recalcPrecise) */
      if (confident && !soldOut) {
        html += '<p class="ids-match" style="display:flex;justify-content:center;margin-top:4px;">✓ התאמה גבוהה לפי נתוני הדגם</p>';
      }
      html += '<p class="ids-note">ההמלצה היא כלי עזר בלבד · ניתן להחליף בקלות לפי מדיניות ההחלפות</p>';
      outEl.innerHTML = html;
      outEl.removeAttribute('hidden');
      root.classList.add('ids-has-result');
      updateSummary(sizeLabel);
      setRecProperty(soldOut ? null : sizeLabel);
      scheduleRecommendClose();

      if (sizeLabel !== lastSize) {
        lastSize = sizeLabel;
        // Restart the result animation without forcing a synchronous layout.
        if (resultAnimation) resultAnimation.cancel();
        if (outEl.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          resultAnimation = outEl.animate([
            { opacity: 0, transform: 'translateY(7px) scale(.98)' },
            { opacity: 1, transform: 'none' }
          ], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
        if (soldOut) {
          clearRecPill();
          selectSizeForNotify(sizeLabel);
          if (userInteracted) track('sold_out', { size: sizeLabel });
        } else {
          manualOverride = false;
          autoSelectSize(sizeLabel);
          injectRecPillFor(sizeLabel);

          /* v13: אירוע recommend רק אחרי אינטראקציה - לא על שחזור מ-localStorage בטעינה */
          if (userInteracted) track('recommend', { size: sizeLabel, chart: chartKey, path: activePath });
        }
      }
      wireResultButtons(sizeLabel, expected);
      refreshAtcLabelSoon();
      if (soldOut) loadAlts(sizeLabel);
    }

    function wireResultButtons(sizeLabel, expected) {
      var pick = $('[data-ids="pick"]', outEl);
      if (pick) {
        pick.addEventListener('mousedown', function (e) { e.preventDefault(); });
        pick.addEventListener('click', function () { fallbackAdd(sizeLabel, expected, pick); });
      }
      var recEdit = $('[data-ids="recedit"]', outEl);
      if (recEdit) recEdit.addEventListener('click', function () { markInteracted(); expandInputs(); });
    }

    function fallbackAdd(sizeLabel, expected, btn) {
      if (pickBusy || !expected || !window.fetch) return;
      pickBusy = true;
      btn.classList.add('is-busy');
      btn.textContent = 'מוסיפים לסל...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: expected.id, quantity: 1, properties: { '_size_finder': sizeLabel + ' · כפתור המחשבון' } })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        track('add_to_cart', { size: sizeLabel, method: 'api' });
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.textContent = 'נוסף לסל · מידה ' + sizeLabel;
        setTimeout(function () { pickBusy = false; if (detailsEl) detailsEl.open = false; }, DONE_CLOSE);
      }).catch(function () {
        pickBusy = false;
        btn.classList.remove('is-busy');
        btn.textContent = 'הוספה לסל · מידה ' + sizeLabel;
      });
    }

    function recalc() {
      if (pickBusy) return;
      errorEl.setAttribute('hidden', '');
      if (activePath === 'quick') recalcQuick();
      else recalcPrecise();
    }

    /* v13: אם המידה המומלצת לא קיימת כווריאנט במוצר (למשל ג'קט בלי XS),
       נופלים למידה הקיימת הקרובה ביותר (עדיפות לגדולה) ומסבירים. */
    function resolveExisting(idx) {
      var sizes = chart().sizes;
      idx = clampIdx(idx, sizes.length);
      if (!variantsMap || variantsMap[sizes[idx]]) return { idx: idx, note: '' };
      var want = sizes[idx];
      for (var d = 1; d < sizes.length; d++) {
        if (idx + d < sizes.length && variantsMap[sizes[idx + d]]) {
          return { idx: idx + d, note: 'הדגם הזה מתחיל מ-' + sizes[idx + d] + ' - רגילה ל-' + want + '? ' + sizes[idx + d] + ' היא המידה הקרובה ותשב טוב.' };
        }
        if (idx - d >= 0 && variantsMap[sizes[idx - d]]) {
          return { idx: idx - d, note: 'הדגם הזה נגמר ב-' + sizes[idx - d] + ' - זו המידה הקרובה ל-' + want + ' שקיימת בו.' };
        }
      }
      return { idx: idx, note: '' };
    }

    function recalcQuick() {
      if (!quickUsual) {
        hideOut(); updateSummary(null); lastSize = null; promptEl.textContent = '';
        return;
      }
      promptEl.textContent = '';
      var sizes = chart().sizes;
      var i = sizes.indexOf(quickUsual);
      var virtualXS = false;
      if (i < 0 && quickUsual === 'XS') { i = 0; virtualXS = true; }
      if (i < 0) { hideOut(); updateSummary(null); lastSize = null; return; }
      var bumped = false;
      var shift = fitShift(fitStats);
      var runsSmall = shift > 0, runsWide = shift < 0;
      var wantUp = runsSmall || (quickFit === 'relaxed' && !runsWide);
      if (virtualXS) wantUp = false; /* S כבר מידה מעל ה-XS הרגילה - לא מקפיצים שוב */
      if (wantUp && i < sizes.length - 1) { i += 1; bumped = true; }
      i = clampIdx(i, sizes.length);
      var reason = '';
      if (virtualXS) {
        reason = 'הדגם מתחיל מ-' + sizes[0] + ' - רגילה ל-XS? ' + sizes[i] + ' תשב לך טוב.';
      } else if (runsSmall) {
        reason = bumped ? 'לפי ' + (fitStats.n || 'ה') + ' ביקורות, בדגם הזה המידה שמעל הרגילה יושבת טוב יותר - לכן המלצנו עליה.' : 'בדגם הזה נהוג לעלות מידה, אבל זו המידה הגדולה ביותר בדגם.';
      } else if (quickFit === 'relaxed' && runsWide) {
        reason = 'הגזרה של הדגם רחבה ממילא - המידה הרגילה תיתן את המראה המשוחרר.';
      } else if (quickFit === 'relaxed') {
        reason = bumped ? 'מידה מעל הרגיל, לישיבה נוחה יותר.' : 'זו כבר המידה הגדולה ביותר בדגם.';
      }
      var ex = resolveExisting(i);
      if (ex.note) reason = ex.note;
      renderResult(sizes[ex.idx], reason, false);
      setInputSum('מידה רגילה: ' + quickUsual + (quickFit === 'relaxed' ? ' · גזרה משוחררת' : ' · גזרה רגילה'));
    }

   function recalcPrecise() {
      var c = chart();
      var midTyping = c.fields.some(function (f) {
        var el = inputs[f];
        if (!el || el.value === '' || el.hasAttribute('hidden')) return false;
        var v = parseFloat(el.value);
        var minPlausible = (f === 'height') ? 100 : 40;
        return isNaN(v) || v < minPlausible;
      });
      if (midTyping) return;
      var vals = readVals();
      saveMeasures({
        bust: inputs.bust ? inputs.bust.value : '', waist: inputs.waist ? inputs.waist.value : '',
        hips: inputs.hips ? inputs.hips.value : '', height: inputs.height ? inputs.height.value : ''
      });

      var required = c.fields.filter(function (f) {
        return f !== 'height' && !(c.optional && c.optional.indexOf(f) >= 0);
      });
      var missing = required.filter(function (f) { return vals[f] == null; });

      if (missing.length) {
        hideOut(); updateSummary(null); lastSize = null;
        var any = Object.keys(vals).length > 0;
        promptEl.textContent = any
          ? 'נשאר רק ' + missing.map(function (f) { return FIELD_NAMES[f]; }).join(' ו') + ' להמלצה'
          : '';
        return;
      }
      promptEl.textContent = '';

      var res = compute(c, vals);
      if (res.error) {
        hideOut(); updateSummary(null); lastSize = null;
        errorEl.innerHTML = res.error + ' מתלבטת? <a href="' + contactUrl + '">כתבי לנו - נשמח לעזור</a>.';
        errorEl.removeAttribute('hidden');
        var errKey = (res.field || '') + ':' + (res.dir || '');
        if (errKey !== lastErrKey) {
          lastErrKey = errKey;
          track('out_of_range', { chart: chartKey, field: res.field || '', direction: res.dir || '' });
        }
        return;
      }
      lastErrKey = null;

      var shiftP = fitShift(fitStats);
      var runsSmallP = shiftP > 0, runsWideP = shiftP < 0;
      var idxP = res.idx, hintP = res.hint || '';
      var bumpedP = false;
      if (runsSmallP && idxP < c.sizes.length - 1) {
        idxP += 1; bumpedP = true;
        hintP = 'לפי ' + (fitStats.n || 'ה') + ' ביקורות, בדגם הזה המידה שמעל הטבלה יושבת טוב יותר - לכן ההמלצה היא מידה אחת מעל המדדים שלך.';
      } else if (runsSmallP) {
        hintP = (hintP ? hintP + ' ' : '') + 'בדגם הזה נהוג לעלות מידה, וזו המידה הגדולה ביותר בדגם.';
      } else if (runsWideP && idxP <= 2 && idxP > 0 && res.spread === 0 && !res.edge) {
        /* v13: הג'קט רחב במותן במידות הקטנות (XS-M) - ההצעה לרדת מידה
           רק שם, רק בלי פער בין המדדים ולא על הגבול העליון */
        hintP = (hintP ? hintP + ' ' : '') + 'לפי ביקורות הגזרה רחבה במותן במידות האלה - מעדיפה מראה צמוד? ' + c.sizes[idxP - 1] + ' גם תתאים.';
      }
      /* v13: edge_hint (למשל "בין XS ל-S? רוב הלקוחות מרוצות מה-S") - רק על הגבול העליון של XS */
      if (!bumpedP && res.edge && idxP === 0 && res.spread === 0 && fitStats && fitStats.edge_hint) {
        hintP = String(fitStats.edge_hint);
      }
      var exP = resolveExisting(idxP);
      if (exP.note) hintP = exP.note;
      /* v13: "התאמה גבוהה" רק כשיש בסיס: מדידה, בתוך הטווח (לא על הגבול),
         בלי פער בין המדדים, בדגם שיושב לפי המידה ובלי נפילה למידה אחרת */
      var confident = !!(fitStats && fitStats.tts === true && (+fitStats.n || 0) >= 20 &&
                         res.spread === 0 && !res.edge && !bumpedP && !res.heightBumped && !exP.note && shiftP === 0);
      renderResult(c.sizes[exP.idx], hintP, confident);

      var parts = [];
      c.fields.forEach(function (f) {
        if (vals[f] == null) return;
        if (f === 'height') parts.push('גובה ' + vals[f]);
        else parts.push(FIELD_NAMES[f].replace('היקף ', '') + ' ' + vals[f]);
      });
      setInputSum(parts.join(' · '));
    }

    function debouncedRecalc() {
      clearTimeout(timer);
      timer = setTimeout(recalc, 600);
    }

    Object.keys(inputs).forEach(function (f) {
      if (!inputs[f]) return;
      inputs[f].addEventListener('focus', markInteracted);
      inputs[f].addEventListener('input', markInteracted);
      inputs[f].addEventListener('input', debouncedRecalc);
      inputs[f].addEventListener('change', function () { if (!pickBusy) recalc(); });
      inputs[f].addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var vis = chart().fields.filter(function (g) { return inputs[g]; });
        var i = vis.indexOf(f);
        var next = (i >= 0 && i < vis.length - 1) ? inputs[vis[i + 1]] : null;
        if (next) { next.focus(); }
        else { inputs[f].blur(); clearTimeout(timer); if (!pickBusy) recalc(); }
      });
    });

    if (chartToggle && chartSrc) chartToggle.addEventListener('click', function () { openModal(chartSrc); });
    if (measureBtn && measureSrc) measureBtn.addEventListener('click', function () { openModal(measureSrc); });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        Object.keys(inputs).forEach(function (f) { if (inputs[f]) inputs[f].value = ''; });
        quickUsual = null; quickFit = 'true';
        quickStep = 1;
        buildSizeChips(); buildFitChips();
        applyQuickStep();
        clearSaved();
        clearQuick();
        hideOut();
        errorEl.setAttribute('hidden', '');
        promptEl.textContent = '';
        updateSummary(null);
        lastSize = null;
        autoClosedAfterRecommend = false;
        clearTimeout(recommendCloseTimer);
      });
    }

   var savedInit = loadSaved();
    activePath = (savedInit.bust || savedInit.waist || savedInit.hips) ? 'precise' : 'quick';
    if (activePath === 'quick') {
      var initCat = (chartKey === 'bottom_std' || chartKey === 'bottom_xs_l') ? 'bottom' : 'top';
      var savedQ = loadQuick(initCat);
      if (savedQ.usual) {
        quickUsual = String(savedQ.usual).toUpperCase();
        quickFit = savedQ.fit === 'relaxed' ? 'relaxed' : 'true';
      }
    }
    applyPathClass();
    if (quickEl) quickEl.hidden = (activePath !== 'quick');
    if (preciseEl) preciseEl.hidden = (activePath !== 'precise');
    if (pathTabsEl) {
      var pPrecise0 = $('[data-path="precise"]', pathTabsEl);
      var pQuick0 = $('[data-path="quick"]', pathTabsEl);
      if (pPrecise0) pPrecise0.hidden = (activePath === 'precise');
      if (pQuick0) pQuick0.hidden = (activePath === 'quick');
    }

    buildFitChips();
    applyChart();
    applyMode();

    var saved = loadSaved();
    ['bust', 'waist', 'hips', 'height'].forEach(function (f) {
      if (saved[f] && inputs[f]) inputs[f].value = saved[f];
    });

    recalc();
    dedupeSizePickers();
    placeFitAdviceInline();
    syncPickerAlt();

    sizePickerScope().addEventListener('ids:manual-variant-selection', function () {
      manualOverride = true;
      clearRecPill();
    });

    sizePickerScope().addEventListener('change', function (e) {
      var t = e.target;
      if (!(t && t.matches && t.matches('input[type="radio"]'))) return;
      var v = (t.value || '').trim().toUpperCase();
      if (chart().sizes.indexOf(v) >= 0 && v !== currentRec) {
        manualOverride = true;
        clearRecPill();
      }
      syncPickerAlt();
      setTimeout(refreshAtcLabel, 60);
    }, true);
    refreshAtcLabelSoon();

    if (reopenNext && detailsEl) {
      suppressOpenTrack = true;
      detailsEl.open = true;
      reopenNext = false;
    }
  }

  function initAll() {
    $$('.ids-fms').forEach(function (root) {
      try {
        if (root.dataset.idsReady === 'true' && typeof root.__idsMaintain === 'function') {
          root.__idsMaintain();
        } else {
          initWidget(root);
        }
      } catch (e) { /* one widget should not break the product page */ }
    });
  }

  // Only structural product changes need maintenance. Reviews, cart totals,
  // video controls and the calculator's own result text do not.
  var maintenanceSelector = '.ids-fms, [data-ids="fitadvice"], .product__block--shipping, fieldset, .product-form__input, input[type="radio"], form[action*="/cart/add"], input[name="id"], sticky-atc-bar';
  function affectsSizePicker(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches('.ids-fms') || node.querySelector('.ids-fms')) return true;
    if (node.closest('.ids-fms')) return false;
    return node.matches(maintenanceSelector) || !!node.querySelector(maintenanceSelector);
  }
  var moScheduled = false;
  function startObserver() {
    if (!document.body || !('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      if (moScheduled) return;
      var relevant = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, affectsSizePicker) ||
               Array.prototype.some.call(record.removedNodes, affectsSizePicker);
      });
      if (!relevant) return;
      moScheduled = true;
      requestAnimationFrame(function () {
        moScheduled = false;
        initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); startObserver(); });
  } else {
    initAll();
    startObserver();
  }
})();
(function(){
  function tipFor(b){return b && b.parentElement ? b.parentElement.querySelector('[data-ids="fittip"]') : null;}
  function place(t,b){
    var r=b.getBoundingClientRect();
    var w=t.offsetWidth || 240;
    var left=Math.max(8,Math.min(window.innerWidth-w-8,r.left+(r.width/2)-(w/2)));
    t.style.top=(r.bottom+8)+'px';
    t.style.left=left+'px';
  }
  function hideAll(except){
    document.querySelectorAll('.ids-fittip').forEach(function(t){
      if(t===except)return;
      t.hidden=true;
      var btn=t.parentElement&&t.parentElement.querySelector('[data-ids="fitinfo"]');
      if(btn)btn.setAttribute('aria-expanded','false');
    });
  }
  function showTip(b){
    var t=tipFor(b);if(!t)return;
    hideAll(t);
    t.textContent=b.getAttribute('data-tip')||'';
    t.hidden=false;
    b.setAttribute('aria-expanded','true');
    requestAnimationFrame(function(){place(t,b);});
  }
  function hideTip(b){
    var t=tipFor(b);if(!t)return;
    t.hidden=true;
    b.setAttribute('aria-expanded','false');
  }
  function toggleTip(e){
    var b=e.target.closest('[data-ids="fitinfo"]');
    if(!b)return;
    e.preventDefault();
    e.stopPropagation();
    var t=tipFor(b);if(!t)return;
    if(t.hidden)showTip(b);else hideTip(b);
  }
  document.addEventListener('pointerup',toggleTip,true);
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-ids="fitinfo"]'))return;
    if(e.target.closest('.ids-fittip'))return;
    hideAll();
  },true);
  ['scroll','resize'].forEach(function(ev){
    window.addEventListener(ev,function(){hideAll();},true);
  });
  if(window.matchMedia&&window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mouseover',function(e){var b=e.target.closest('[data-ids="fitinfo"]');if(b)showTip(b);});
    document.addEventListener('mouseout',function(e){var b=e.target.closest('[data-ids="fitinfo"]');if(b)hideTip(b);});
  }
})();


}
